import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { IDeviceType } from 'src/app/shared/models/IDevice-type';
import { ResourcesService } from 'src/app/shared/services/resources.service';
import { Sort } from 'src/app/shared/util/sort';
import { DeviceTypeService } from './shared/device-type.service';

@Component({
  selector: 'app-device-types',
  templateUrl: './device-types.component.html',
  styleUrls: ['./device-types.component.css']
})
export class DeviceTypesComponent implements OnInit {
  resourceKeyValue: any;
  isLoading: boolean = false;
  pageSizeOptions = [];
  pageSize = 25;
  pageSizeDisplay = 25;
  pageIndex = 1;
  numberOfPages = 0;
  totalNumber: number;
  directionColumnName: string = 'asc';
  sortableState = '1';
  searchDeviceTypesForm = this.fb.group({
    term: [''],
  });

  isDefaultSort = true;
  deviceTypes: IDeviceType[];
  deviceTypes2display: IDeviceType[];
  rowDeviceTypes: IDeviceType[];

  @ViewChild("deviceTypeTable", { read: ElementRef }) deviceTypeTable: ElementRef;

  constructor(private resourcesService: ResourcesService,
    private fb: UntypedFormBuilder,
    private renderer: Renderer2,
    public toastrService: ToastrService,
    private deviceTypeService: DeviceTypeService,) { }
  ngOnInit(): void {
    this.resourcesService.bsObject
      .subscribe((result: any) => {
        result && (this.resourceKeyValue = result);
        this.pageSizeOptions = [10, 25, 50, 100, { showAll: this.resourceKeyValue.showAll }];
        this.getDeviceTypes();
      });
  }
  getDeviceTypes(): void {
    this.isLoading = true;

    this.deviceTypeService.getAllDeviceTypesWithModelsCount().subscribe(response => {
      if (response && response.length > 0) {
        this.rowDeviceTypes = response;
        this.deviceTypes = this.rowDeviceTypes;
        this.totalNumber = this.rowDeviceTypes.length;
        this.numberOfPages = Math.ceil(this.totalNumber / this.pageSize);
        //first ordering the records by name asc
        this.columnSort('name', this.directionColumnName);
      }
      this.isLoading = false;
    },
      (error) => {
        if (error.code == 404) {
          this.deviceTypes = [];
          this.rowDeviceTypes = [];
          this.searchDeviceTypesForm.controls['term'].disable();
          this.isLoading = false;
          return;
        }
      });
  }
  search(e: string) {
    this.isDefaultSort = true;
    this.deviceTypes = this.rowDeviceTypes;
    this.deviceTypes = this.deviceTypes.filter(x => this.matches(x, e));
    this.totalNumber = this.deviceTypes.length;
    this.refreshDeviceTypes();
    this.columnSort('name', this.directionColumnName);
  }
  refreshDeviceTypes() {
    this.isDefaultSort = true;
    this.deviceTypes2display = this.deviceTypes
      .map((device, i) => ({ id: i + 1, ...device }))
      .slice((this.pageIndex - 1) * this.pageSize, (this.pageIndex - 1) * this.pageSize + this.pageSize);
    this.numberOfPages = Math.ceil(this.totalNumber / this.pageSize);

    if (this.deviceTypeTable) {
      let elements: Element[] = this.deviceTypeTable.nativeElement.getElementsByClassName('sorted-desc') || this.deviceTypeTable.nativeElement.getElementsByClassName('sorted-asc');
      if (elements && elements.length) {
        Array.from(elements).forEach((element: any) => {
          this.renderer.removeClass(element, 'sorted-desc');
          this.renderer.removeClass(element, 'sorted-asc');

          if (element.getAttribute('data-order') && element.getAttribute('data-order') == 'asc') {
            element.setAttribute('data-order', 'desc');
          }
        });
      }

      let sortElement = this.deviceTypeTable.nativeElement.getElementsByClassName('initialSort');
      if (sortElement && sortElement.length) {
        this.renderer.addClass(sortElement[0], 'sorted-asc');
      }
    }

    this.sortableState = '1';
    this.columnSort('name', this.directionColumnName);
  }

  columnSort(property: string, direction: string) {
    const dataSort = new Sort();
    this.deviceTypes.sort(dataSort.startSort(property, direction));
  }

  matches(device: IDeviceType, term: string) {
    return device.name.toLowerCase().includes(term.toLocaleLowerCase());
  }

  isNumber(val): boolean { return typeof val === 'number'; }
}
